// extracted by mini-css-extract-plugin
export default {"message":"message---V7uJK","message__content":"message__content---KLk6c","error":"error---FqwsN","stack":"stack---yj1Ut"};